const envSettings = window as any;

export default class ConfigProvider {
  public static Base_URL = envSettings.window.APP_ROOT_API;
  public static App_Name = envSettings.window.APP_NAME;
  public static Max_Time_Vehicle_Position = envSettings.window.APP_MAX_TIME_VEHICLE_POSITION;
}
